/** Appended to `document.body` while a dashboard panel is dragged. */
export const DASH_SORTABLE_DRAG_PREVIEW_CLASS = "dash-sortable-drag-preview";

/** Inserted into a column to mark the drop target during drag. */
export const DASH_SORTABLE_PLACEHOLDER_CLASS = "dash-sortable-placeholder";

export const DASH_SORTABLE_LIST_ATTR = "s25-dash-sortable-list";

export const DASH_SORTABLE_PANEL_SELECTOR = ".d-panel.section";

export const DASH_SORTABLE_HANDLE_SELECTOR = ".sortable-handle";

/** Pixels before pointer movement becomes a drag (avoids accidental drags on click/focus). */
export const DASH_SORTABLE_DRAG_THRESHOLD_PX = 5;
